"use client"
import { useSelector } from "react-redux"
import PageHeader from "../../../components/common/PageHeader"
import "../../../resources/scss/privacy-policy.scss"

function PrivacyPolicy() {
    const { isMobile } = useSelector((state) => state.config)

    return (
        <div className="privacy-policy-container">
            <div className={`privacy-content ${isMobile ? "mobile" : "desktop"}`}>
                <div className="privacy-section">
                    <h2>제1조 (개인정보의 처리목적)</h2>
                    <p>
                        본 교회는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
                        이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한
                        조치를 이행할 예정입니다.
                    </p>
                    <ul>
                        <li>교회 회원 관리 및 신분 확인</li>
                        <li>교회 소식 및 예배 안내</li>
                        <li>각종 행사 및 프로그램 참여 관리</li>
                        <li>온라인 서비스 제공 및 회원제 서비스 이용</li>
                        <li>교회 운영을 위한 통계 작성</li>
                    </ul>

                    <h3>회원가입 시 수집 항목</h3>
                    <p>아래와 같은 항목을 회원가입 시 수집하며, 목적 달성을 위해 최소한의 정보만 수집합니다.</p>

                    <div className="collection-table">
                        <table>
                            <thead>
                            <tr>
                                <th>수집 목적</th>
                                <th>수집 항목</th>
                                <th>수집 조건</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>회원 식별 및 관리</td>
                                <td>이름, 연락처(휴대폰), 생년월일</td>
                                <td>필수</td>
                            </tr>
                            <tr>
                                <td>예배 안내 및 소식 전달</td>
                                <td>이메일, 휴대폰 번호</td>
                                <td>선택</td>
                            </tr>
                            <tr>
                                <td>행사 및 프로그램 참여 안내</td>
                                <td>이름, 휴대폰 번호, 참여 이력</td>
                                <td>필수</td>
                            </tr>
                            <tr>
                                <td>통계 분석 및 서비스 개선</td>
                                <td>서비스 이용 기록, 접속 로그, 쿠키, 접속 IP</td>
                                <td>선택</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제2조 (개인정보의 처리 및 보유기간)</h2>
                    <p>
                        본 교회는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보
                        보유·이용기간 내에서 개인정보를 처리·보유합니다.
                    </p>
                    <div className="retention-table">
                        <table>
                            <thead>
                            <tr>
                                <th>처리목적</th>
                                <th>보유기간</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>회원 관리</td>
                                <td>회원 탈퇴 시까지</td>
                            </tr>
                            <tr>
                                <td>교회 소식 발송</td>
                                <td>동의 철회 시까지</td>
                            </tr>
                            <tr>
                                <td>행사 참여 관리</td>
                                <td>행사 종료 후 1년</td>
                            </tr>
                            <tr>
                                <td>온라인 서비스 이용</td>
                                <td>서비스 이용 종료 시까지</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제3조 (개인정보의 제3자 제공)</h2>
                    <p>
                        본 교회는 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의
                        특별한 규정 등 개인정보보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
                    </p>
                    <div className="highlight-box">
                        <p>
                            <strong>현재 본 교회는 개인정보를 제3자에게 제공하지 않습니다.</strong>
                        </p>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제4조 (개인정보처리의 위탁)</h2>
                    <p>본 교회는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
                    <div className="delegation-table">
                        <table>
                            <thead>
                            <tr>
                                <th>위탁받는 자</th>
                                <th>위탁하는 업무의 내용</th>
                                <th>위탁기간</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>웹사이트 호스팅 업체</td>
                                <td>웹사이트 운영 및 관리</td>
                                <td>서비스 이용 기간</td>
                            </tr>
                            <tr>
                                <td>이메일 발송 서비스</td>
                                <td>교회 소식 이메일 발송</td>
                                <td>서비스 이용 기간</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제5조 (정보주체의 권리·의무 및 행사방법)</h2>
                    <p>정보주체는 본 교회에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                    <ul>
                        <li>개인정보 처리현황 통지 요구</li>
                        <li>개인정보 열람 요구</li>
                        <li>개인정보 정정·삭제 요구</li>
                        <li>개인정보 처리정지 요구</li>
                    </ul>
                    <div className="contact-info">
                        <h3>권리 행사 방법</h3>
                        <p>
                            위의 권리 행사는 개인정보보호법 시행규칙 별지 제8호에 따라 작성하여 서면, 전자우편, 모사전송(FAX) 등을
                            통하여 하실 수 있으며, 본 교회는 이에 대해 지체없이 조치하겠습니다.
                        </p>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제6조 (개인정보의 파기)</h2>
                    <p>
                        본 교회는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당
                        개인정보를 파기합니다.
                    </p>
                    <div className="destruction-method">
                        <h3>파기 방법</h3>
                        <ul>
                            <li>
                                <strong>전자적 파일 형태:</strong> 기록을 재생할 수 없도록 로우레벨포맷(Low Level Format) 등의 방법을
                                이용하여 파기
                            </li>
                            <li>
                                <strong>종이 문서:</strong> 분쇄기로 분쇄하거나 소각하여 파기
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="privacy-section">
                    <h2>제7조 (개인정보의 안전성 확보조치)</h2>
                    <p>
                        본 교회는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고
                        있습니다.
                    </p>
                    <ul>
                        <li>개인정보 취급 직원의 최소화 및 교육</li>
                        <li>개인정보에 대한 접근 제한</li>
                        <li>개인정보를 안전하게 저장·전송할 수 있는 암호화 기법 사용</li>
                        <li>해킹 등에 대비한 기술적 대책</li>
                        <li>개인정보의 안전한 보관을 위한 보관시설의 마련 또는 잠금장치 설치</li>
                    </ul>
                </div>

                <div className="privacy-section">
                    <h2>제8조 (개인정보 보호책임자)</h2>
                    <p>
                        본 교회는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및
                        피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                    </p>

                    <div className="contact-card">
                        <h3>개인정보 보호책임자</h3>
                        <div className="contact-details">
                            <p>
                                <strong>성명:</strong> 김진영 목사
                            </p>
                            <p>
                                <strong>직책:</strong> 개인정보 보호책임자
                            </p>
                            <p>
                                <strong>연락처:</strong> 010-8904-6418
                            </p>
                            <p>
                                <strong>이메일:</strong> wlsdud6419@naver.com
                            </p>
                        </div>
                    </div>

                </div>

                <div className="privacy-section">
                    <h2>제9조 (개인정보 처리방침의 변경)</h2>
                    <p>
                        이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는
                        경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
                    </p>

                    <div className="version-info">
                        <p>
                            <strong>공고일자:</strong> 2025년 7월 1일
                        </p>
                        <p>
                            <strong>시행일자:</strong> 2025년 7월 1일
                        </p>
                    </div>
                </div>

                <div className="privacy-section last-section">
                    <h2>제10조 (권익침해 구제방법)</h2>
                    <p>정보주체는 아래의 기관에 대해 개인정보 침해신고를 할 수 있습니다.</p>

                    <div className="remedy-contacts">
                        <div className="remedy-item">
                            <h4>개인정보보호위원회</h4>
                            <p>전화: (국번없이) 1833-6972</p>
                            <p>홈페이지: privacy.go.kr</p>
                        </div>

                        <div className="remedy-item">
                            <h4>개인정보 침해신고센터</h4>
                            <p>전화: (국번없이) privacy.go.kr</p>
                            <p>홈페이지: privacy.go.kr</p>
                        </div>

                        <div className="remedy-item">
                            <h4>대검찰청</h4>
                            <p>전화: (국번없이) 1301</p>
                            <p>홈페이지: www.spo.go.kr</p>
                        </div>

                        <div className="remedy-item">
                            <h4>경찰청</h4>
                            <p>전화: (국번없이) 182</p>
                            <p>홈페이지: ecrm.cyber.go.kr</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy
